import { BottomSheet, Box, Button, Modal, TextLink, Typography, useMediaQueryContext } from "@drone-js/core";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import { type FunctionComponent, useState } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

export const DifferentLocationModal: FunctionComponent = () => {
    const {
        propertyTypeCms: { okay },
        singleMultipleCms: {
            hereAreSomeExamplesOfProperties,
            apartmentsInDifferentBuildings,
            bungalowsOnDifferentBeaches,
            villasInTheSameTown,
            toEnsureAccuratePricing,
            havePropertiesInDifferentLocations,
            areYourPropertiesAtDifferentLocations,
        },
    } = usePropertySelectionViewModelValue();
    const [open, setOpen] = useState(false);
    const { m: isDesktopSize } = useMediaQueryContext();

    const content = (
        <Box p="16" qM={{ p: "0" }}>
            <Box
                height="140px"
                width="100%"
                backgroundColor="base.background"
                borderRadius="8"
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <img
                    alt="different location"
                    src={OneOnboardingImages.SingleMultipleDifferentLocation}
                    height="108px"
                    width="auto"
                />
            </Box>
            <Box mt="16">
                <Typography variant="body-s" textColor="base.default">
                    {hereAreSomeExamplesOfProperties}
                </Typography>
                <Typography variant="body-s" textColor="base.default">
                    <ul>
                        <li>{apartmentsInDifferentBuildings}</li>
                        <li>{bungalowsOnDifferentBeaches}</li>
                        <li>{villasInTheSameTown}</li>
                    </ul>
                </Typography>
                <Typography variant="body-s" textColor="base.default" mt="16">
                    {toEnsureAccuratePricing}
                </Typography>
            </Box>
            <Box mt="16" display="flex" justifyContent="end">
                <Button
                    variant="label"
                    size="l"
                    label={okay}
                    onClick={() => setOpen(false)}
                    width={isDesktopSize ? "content-fit" : "parent-fit"}
                    data-element-name="okay"
                />
            </Box>
        </Box>
    );

    return (
        <>
            <Box display="flex">
                <TextLink
                    hierarchy="primary"
                    label={havePropertiesInDifferentLocations}
                    leadingIcon="fill.symbol.circle-question"
                    onClick={() => setOpen(true)}
                    data-element-name="properties-in-different-locations-link"
                />
            </Box>
            {isDesktopSize ? (
                <Modal visible={open} onClose={() => setOpen(false)} title={areYourPropertiesAtDifferentLocations}>
                    {content}
                </Modal>
            ) : (
                <BottomSheet
                    visible={open}
                    onChange={() => setOpen(false)}
                    title={areYourPropertiesAtDifferentLocations}
                    closeButton={{
                        "aria-label": "Close",
                    }}
                >
                    {content}
                </BottomSheet>
            )}
        </>
    );
};
